import React from "react";
import { Box } from "@mui/system";

import { Legend } from "../../../../components";
import Header from "../reportSegment/header";
import ComparisonTable from "./comparisonTable";
import DriversProgressionPopup from "./driversProgressionPopup";
import SegmentTable from "../reportSegmentV2/segmentTable";

import {
  ContentWrap,
  GridHeaderWrapper,
  SegmentTableWrapper,
} from "./style";

const TAB_CONFIG = {
  type: 'SearchKeywords',
  filterType: 'periods',
  attributeColor: '#000',
  tabs: [
    { id: 0, label: 'Comparision view', tutorial: 'Comparision view' },
    { id: 1, label: 'Periodic view', tutorial: 'Periodic view' },
  ],
  showLegends: false,
}

const NewComponent = ({
  activeTab2,
  setActiveTab2,
  segmentData,
  eventCount,
  progressionRangeObject,
  props,
  keyOrdering,
  maxValue,
  state,
  CONFIG,
  expandedStatus,
  setEventCount,
  periodInOrder,
  progressionRangeArray,
  popupDropdownArray,
  popupDropdownArrayWithAllMonths,
  driverProgressionPopupObject,
  reportDataNew,
  legendsData,
}) => {
  return (
    <>
      <GridHeaderWrapper className="tabWrapper">
        <Header
          options={TAB_CONFIG.tabs}
          value={activeTab2}
          onChange={setActiveTab2}
          styletype="themeV2"
        />
      </GridHeaderWrapper>

      {activeTab2 === 0 && Object.keys(segmentData || {}).length > 0 && (
        <>
          <ContentWrap className="segmentWrapper">
            {eventCount && progressionRangeObject?.title && (
              <ComparisonTable
                parentTypeIdL1={props.type}
                keyOrdering={keyOrdering}
                isSearchDrivers={props.isSearchDrivers}
                maxValue={maxValue}
                data={state}
                segmentData={segmentData}
                type={CONFIG[props.InsightsElementType]?.type}
                filterType={CONFIG[props.InsightsElementType]?.filterType}
                insightsElementType={props.InsightsElementType}
                insightsElementId={props.InsightsElementId}
                expanded={expandedStatus}
                filterUpdated={() => setEventCount((prev) => prev + 1)}
                periodInOrder={periodInOrder}
                progressionRangeObject={progressionRangeObject}
                progressionRangeArray={progressionRangeArray}
                isPPTModalActive={props.isPPTModalActive}
                updateProgressionRange={eventCount}
              />
            )}
          </ContentWrap>

          {CONFIG[props.InsightsElementType]?.showLegends && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                mt: 3.5,
              }}
            >
              <Legend legends={legendsData} />
            </Box>
          )}

          {popupDropdownArrayWithAllMonths?.length > 0 &&
            driverProgressionPopupObject?.showId ===
              props.InsightsElementId &&
            driverProgressionPopupObject?.level_1 && (
              <DriversProgressionPopup
                popupDropdownArray={popupDropdownArray}
                popupDropdownArrayWithAllMonths={
                  popupDropdownArrayWithAllMonths
                }
                keyOrdering={keyOrdering}
                insightsElementType={props.InsightsElementType}
              />
            )}
        </>
      )}

      {activeTab2 === 1 && (
        <SegmentTableWrapper>
          <SegmentTable
            data={reportDataNew?.slice(
              0,
              progressionRangeObject?.barsInGraph
            )}
            isSearchDrivers={props.isSearchDrivers}
            showAttributes={!props.isDriversProgression}
            hideTopBlueBar={props.hideTopBlueBar}
            type={CONFIG[props.InsightsElementType]?.type}
            attributeColor={
              CONFIG[props.InsightsElementType]?.attributeColor
            }
            insightsElementType={props.InsightsElementType}
            showTableGrid={null}
            maxValue={maxValue}
            props={props}
          />
        </SegmentTableWrapper>
      )}
    </>
  );
};

export default NewComponent;